import React from 'react';
import MultiSelectCellComponentWithSearch from 'views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch';
const ViewReceiptId = ({ rowData }) => {
    const { action, status, remark } = rowData;
    console.log("rowData in ViewReceiptId", action, status, remark );
    const isReceiptIdAvailable = action?.toLowerCase().includes('receipt') && !action?.toLowerCase().includes('receipt generation') && status?.toLowerCase() == 'completed';
    // if available then split the remark section on the basis of comma to  array
    const receiptIds = isReceiptIdAvailable ? remark?.split(',') : [];
    console.log("receiptIds", receiptIds);
    return (isReceiptIdAvailable ? <MultiSelectCellComponentWithSearch
        title={"Receipt Id"}
        data={receiptIds}
        text={"View Receipt Id"}
    /> : ''
    );
}
export default ViewReceiptId;